<div
  class="sino btn-group"
  dropdown
  [isOpen]="aberto()"
  (isOpenChange)="aberto.set($event)"
  placement="bottom right"
>
  <button
    type="button"
    class="sino__botao"
    dropdownToggle
    [attr.aria-label]="
      naoLidas() > 0 ? naoLidas() + ' avisos não lidos' : 'Avisos'
    "
  >
    <i class="bx bx-bell"></i>
    @if (naoLidas() > 0) {
      <span class="sino__badge">{{ contador() }}</span>
    }
  </button>

  <div *dropdownMenu class="dropdown-menu dropdown-menu-end sino__painel" role="menu">
    <header class="sino__cabecalho">
      <span>Avisos</span>
      <button
        type="button"
        class="sino__marcar-todas"
        [disabled]="naoLidas() === 0"
        (click)="marcarTodasLidas()"
      >
        Marcar todas como lidas
      </button>
    </header>

    @if (vazio()) {
      <p class="sino__vazio">Nenhum aviso por aqui.</p>
    } @else {
      <ul class="sino__lista">
        @for (notificacao of notificacoes(); track notificacao.id) {
          <li>
            <button
              type="button"
              class="sino__item"
              [class.sino__item--nao-lida]="!notificacao.lida"
              (click)="abrir(notificacao)"
            >
              <i class="sino__item-icone" [ngClass]="icone(notificacao.tipo)"></i>
              <span class="sino__item-texto">
                <strong>{{ notificacao.titulo }}</strong>
                <small>{{ notificacao.mensagem }}</small>
                <time>{{ notificacao.created_at | date: 'dd/MM/yyyy HH:mm' }}</time>
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>
